module.exports = __webpack_public_path__ + "static/media/whiteCloseIcon.afe70a61.svg";